export default __webpack_public_path__ + "static/media/photo--sm--65.179cf277.jpg";